import { TailSpin } from "react-loader-spinner";
import styled from "styled-components";

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const LoadingText = styled.div`
  font-size: 14px;
  color: rgba(0, 0, 0, 0.45);
`;

const UnlinkLoader = () => (
  <Wrapper>
    <TailSpin color="black" height={20} width={20} />
    <LoadingText>Unlinking your voter record...</LoadingText>
  </Wrapper>
);

export default UnlinkLoader;
